<script setup>

</script>

<template>
  <div class="emptyCard">
    Нет данных
  </div>
</template>

<style scoped lang="scss">
.emptyCard {
  text-align: left;
  padding: 34px;
  border-radius: 20px;
  background-color: var(--cd-card-bg);
  min-height: 380px;
}

</style>